<template>
  <div class="flex flex-col gap-4 w-full">
    <div class="aspect-[15/18] bg-[hsl(0,0%,85%)]"></div>
    <div class="flex flex-col gap-2">
      <div class="w-1/2 h-5 bg-[hsl(0,0%,85%)]"></div>
      <div class="w-1/4 h-8 bg-[hsl(0,0%,85%)]"></div>
    </div>
  </div>
</template>
